import { usePostAuthorization } from "@sprout/client-components/dist/Post";
import useAssignMany from "@sprout/client-components/dist/Dialog_next/AssignmentDialog/graphql/mutations/useAssignMany";
import useCurrentUser from "@sprout/client-graphql/dist/useCurrentUser";
import { useActionRegistryGlobalHandler } from "@sprout/list-navigation";
import { useCallback, useMemo } from "react";
import { isNotNull } from "sprout-lib";
import { useFnRef } from "sprout-hooks";
export default function usePostPageSelfAssign(item) {
    const { assignments  } = item;
    const assignees = useMemo(()=>{
        return assignments.map(({ assignee  })=>assignee).filter(isNotNull);
    }, [
        assignments
    ]);
    const currentUser = useCurrentUser();
    const currentUserId = currentUser === null || currentUser === void 0 ? void 0 : currentUser.id;
    const authorization = usePostAuthorization(item);
    const users = useMemo(()=>currentUser ? [
            currentUser
        ] : [], [
        currentUser
    ]);
    const assignMany = useAssignMany(users);
    const assignManyRef = useFnRef(assignMany);
    useActionRegistryGlobalHandler("PAGE_SELF_ASSIGN", useCallback(()=>{
        if (typeof currentUserId !== "undefined") {
            const assigned = !!assignees.find((user)=>user.id === currentUserId);
            assignManyRef.current({
                assigneesToAdd: !assigned ? [
                    currentUserId
                ] : [],
                assigneesToRemove: assigned ? [
                    currentUserId
                ] : [],
                posts: [
                    item
                ]
            });
        }
        return true;
    }, [
        assignManyRef,
        assignees,
        currentUserId,
        item
    ]), {
        skip: !authorization.assign
    });
};
